import profilePicture from "../../assets/profile.png"
import { LanguageSelector } from "./LanguageSelector"
import { t } from 'i18next' 

export function Header() {
  return (
    <header>
      <div className="content-wrapper">
        <div className="hero-image">
          <img src={profilePicture} alt={t('header-alt')}></img>
          <LanguageSelector />
        </div>
        <h1>Simon Renlund</h1>
        <div className="center flow-content profile-wrapper">
          <p>{t('header-tags')}</p>
          <p className="optional-content">{t('header-1')}</p>
          <p className="optional-content">{t('header-2')}</p>
          <p className="optional-content">{t('header-3')}</p>
          <a className="btn cta" href="#contact">{t('header-contact')}</a>
        </div>
      </div>
    </header>
  )
}